import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';

import { TypeCoordComponent } from './typeCoord/type-coord.component';
import { TypeLieuComponent } from './typeLieu/type-lieu.component';
import { TypeCrJugementComponent } from './typeCrJugement/type-cr-jugement.component';
import { OuiComponent } from './oui/oui.component';
import { TypeTableMinMaxComponent } from './typeTableMinMax/type-table-min-max.component';
import { EnvoiComponent } from './envoi/envoi.component';
import { TypeRensAComponent } from './typeRensA/type-rensA.component';
import { TypePersComponent } from './typePers/type-pers.component';
import { TypeDureeMarcheComponent } from './typeDureeMarche/type-duree-marche.component';
import { InfosSupComponent } from './infosSup/infos-sup.component';
import { TypeAdresseComponent } from './typeAdresse/type-adresse.component';
import { TypeAnnexeATAComponent } from './typeAnnexeATA/type-annexeATA.component';
import { TypeTableCar1Component } from './typeTableCar1/type-table-car1.component';
import { LotComponent } from './lot/lot.component';
import { TypeLangueComponent } from './typeLangue/type-langue.component';
import { TypeJustifComponent } from './typeJustif/type-justif.component';
import { TypeOuiNonComponent } from './typeOuiNon/type-oui-non.component';
import { InitialComponent } from './initial/initial.component';
import { TRComponent } from './tR/tR.component';
import { TypeCPVClassComponent } from './typeCPVClass/typeCPV-class.component';
import { ConditionsComponent } from './conditions/conditions.component';
import { CriterePondereComponent } from './criterePondere/critere-pondere.component';
import { DocPrixComponent } from './docPrix/doc-prix.component';
import { DescriptionComponent } from './description/description.component';
import { TypeObjCPVComponent } from './typeObjCPV/type-objCPV.component';
import { MarcheNegocieComponent } from './marcheNegocie/marche-negocie.component';
import { TypeVoieComponent } from './typeVoie/type-voie.component';
import { TypeCaracteristiquesMAPAComponent } from './typeCaracteristiquesMAPA/type-caracteristiquesMAPA.component';
import { QualificationsProfessionnellesComponent } from './qualificationsProfessionnelles/qualifications-professionnelles.component';
import { TypeNatureMarcheLotComponent } from './typeNatureMarcheLot/type-nature-marche-lot.component';
import { ConformiteFournituresComponent } from './conformiteFournitures/conformite-fournitures.component';
import { DocPayantsComponent } from './docPayants/doc-payants.component';
import { RensComplementairesComponent } from './rensComplementaires/rens-complementaires.component';
import { AutorisationSpecifiqueComponent } from './autorisationSpecifique/autorisation-specifique.component';
import { TypeAdresseCompleteComponent } from './typeAdresseComplete/type-adresse-complete.component';
import { ProcedureComponent } from './procedure/procedure.component';
import { RenseignementsComponent } from './renseignements/renseignements.component';
import { TypeLotsMAPAComponent } from './typeLotsMAPA/type-lotsMAPA.component';
import { TypeTableauLibreComponent } from './typeTableauLibre/type-tableau-libre.component';
import { TypeTravauxComponent } from './typeTravaux/type-travaux.component';
import { TypeFournituresComponent } from './typeFournitures/type-fournitures.component';
import { FormmapaInitialComponent } from './formmapa/formmapa.component';
import { Step2Component } from './steps/step2/step2.component';
import { Step3Component } from './steps/step3/step3.component';
import { Step4Component } from './steps/step4/step4.component';
import { Step5Component } from './steps/step5/step5.component';
import { Step6Component } from './steps/step6/step6.component';
import { Step7Component } from './steps/step7/step7.component';
import { Step8Component } from './steps/step8/step8.component';
import { Step9Component } from './steps/step9/step9.component';
import { Step10Component } from './steps/step10/step10.component';
import { Step11Component } from './steps/step11/step11.component';
import { Step12Component } from './steps/step12/step12.component';
import { TypeDelaisComponent } from './typeDelais/typeDelais/type-delais.component';
import { ValiditeComponent } from './validite/validite/validite.component';
import { FormmapaCommonModule } from '../common/formmapa.module';

@NgModule({
  declarations: [

    TypeCoordComponent,
    TypeLieuComponent,
    TypeCrJugementComponent,
    OuiComponent,
    TypeTableMinMaxComponent,
    EnvoiComponent,
    TypeRensAComponent,
    TypePersComponent,
    TypeDureeMarcheComponent,
    InfosSupComponent,
    TypeAdresseComponent,
    TypeAnnexeATAComponent,
    TypeTableCar1Component,
    LotComponent,
    TypeLangueComponent,
    TypeJustifComponent,
    TypeOuiNonComponent,
    InitialComponent,
    TRComponent,
    TypeCPVClassComponent,
    ConditionsComponent,
    CriterePondereComponent,
    DocPrixComponent,
    DescriptionComponent,
    TypeObjCPVComponent,
    MarcheNegocieComponent,
    TypeVoieComponent,
    TypeCaracteristiquesMAPAComponent,
    QualificationsProfessionnellesComponent,
    TypeNatureMarcheLotComponent,
    ConformiteFournituresComponent,
    DocPayantsComponent,
    RensComplementairesComponent,
    AutorisationSpecifiqueComponent,
    TypeAdresseCompleteComponent,
    ProcedureComponent,
    RenseignementsComponent,
    TypeLotsMAPAComponent,
    TypeTableauLibreComponent,
    TypeTravauxComponent,
    TypeFournituresComponent,
    TypeDelaisComponent,
    ValiditeComponent,
    FormmapaInitialComponent,

    Step2Component,

    Step3Component,

    Step4Component,

    Step5Component,

    Step6Component,

    Step7Component,

    Step8Component,

    Step9Component,

    Step10Component,

    Step11Component,

    Step12Component],
  exports: [
    FormmapaInitialComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule, SharedModule, FormmapaCommonModule
  ]
})
export class FormmapaInitialModule {
}

